import React from "react";
import "./App.css";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { Phone, Mail } from "lucide-react";
import { WaveCanvas, SiteNav, SiteFooter } from "./Home";
const profileImg = "/images/wajdi-bouallegue.png";

export default function Contact() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Olympic Wave | Contact</title>
        <meta
          name="description"
          content="Contact Wajdi Bouallègue, former competitive gymnast and current elite coach."
        />
        <meta
          property="og:title"
          content="Contact Olympic Wave - Gymnastics Coaching"
        />
        <meta
          property="og:description"
          content="Get in touch with Wajdi Bouallègue for gymnastics coaching and athlete development programs."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://olympicwave.ca/contact" />
      </Helmet>

      <WaveCanvas />
      <div className="ow-page">
        <SiteNav />

        <main className="ow-inner" style={{ maxWidth: "1200px" }}>
          <div className="ow-page-header">
            <p className="ow-eyebrow">Olympic Wave</p>
            <h1 className="ow-page-title">{t("getintouch")}</h1>
            <p className="ow-page-lead">{t("contact-text")}</p>
          </div>

          <div className="ow-contact-card">
            <div className="ow-contact-photo-wrap">
              <img
                src={profileImg}
                alt="Wajdi Bouallègue elite gymnastics coach and founder of Olympic Wave"
                className="ow-contact-photo"
              />
            </div>

            <div className="ow-contact-info">
              <h2 className="ow-contact-name">{t("nom")}</h2>

              <a href="tel:+13439870303" className="ow-contact-row">
                <span className="ow-contact-icon-wrap">
                  <Phone size={17} strokeWidth={2} />
                </span>
                <span>(343) 987-0303</span>
              </a>

              <a href="mailto:Wajdi@olympicwave.ca" className="ow-contact-row">
                <span className="ow-contact-icon-wrap">
                  <Mail size={17} strokeWidth={2} />
                </span>
                <span>Wajdi@olympicwave.ca</span>
              </a>
            </div>
          </div>
        </main>

        <SiteFooter />
      </div>
    </>
  );
}
